import type { ReactNode } from 'react';
import toast from 'react-hot-toast';

import { CustomToast } from '@/shared/components/custom-toast';

export type ToastOptions = {
  title: string;
  message: string;
  leftIcon?: ReactNode;
  type?: 'success' | 'error' | 'info';
  toastStyle?: 'default' | 'deals';
  position?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right';
};

export const emitToast = ({ position, ...toastProps }: ToastOptions) => {
  return toast.custom(
    ({ id, visible }) => {
      return (
        <CustomToast //
          {...toastProps}
          visible={visible}
          handleClose={() => toast.dismiss(id)}
        />
      );
    },
    {
      duration: 5 * 1000,
      position,
    },
  );
};
